

export type ObjectKeyValue = { fieldName: string, value: any }
export const getObjectKeyValues = (object: any, path: string[] = []): ObjectKeyValue[] => {
    let arr: ObjectKeyValue[] = []

    for (const propName in object) {
        if (object[propName] !== null && typeof object[propName] === 'object' && !object[propName].message && !object[propName].type && !object[propName].ref) // nejedna uz o validacni hlasku
        {
            arr = [...arr, ...getObjectKeyValues(object[propName], [...path, propName])]
        } else {
            arr.push({
                fieldName: [...path, propName].join("."),
                value: object[propName]
            })
        }
    }


    return arr
}